<template>
<div>
    <!-- <p class="responsemessage" v-if="disableStartAddFunds">Please add a card or bank account above before you {{titleText}}</p> -->
    <confirm :body="getConfirmText" :title="titleText" @yes="startAddFunds" :showButton="trueParam" :disabled="disableStartAddFunds" buttonclass="button buttonpay"/>
    
    <!--  MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            

                <div v-if="!showConfirm">
                    <form ref="addfundsform">
                        <label class="titlelabel">{{titleText}} to Account</label>
                        <br/>
                        <p class="subtitleBold">{{googlePayFundRequest.Name}}</p>
                       
                        <formentry inputid="amount"  inputtype="number" :isrequired='trueParam' label="Amount to Add"  v-model="googlePayFundRequest.Amount" />
            
                        <smallbutton  @click="GetTax()" toplabel="Save"/>
                        <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Cancel"/>
                        <div v-if="!showConfirm">
                            <label class="responsemessage">{{responseMessage}}</label>
                        </div>
                    </form>
                </div>
                <div v-if="showConfirm">
                    <form>
                        <div class="vertFlex">
                            <label class="subtitleBold">Confirm {{titleText}} to Account</label>
                            <br/>
                            <label  class="subtitleBold">
                                {{googlePayFundRequest.Name}} 
                            </label>
                            <label class="listtextbold">
                                Amount to Add: {{googlePayFundRequest.Amount | toCurrency}}
                            </label>
                            <label class="listtextbold" v-if="googlePayFundRequest.TaxAmount!='0'">
                                Tax: {{googlePayFundRequest.TaxAmount | toCurrency}}
                            </label>
                            <label class="listtextbold" v-if="googlePayFundRequest.FeeAmount!='0'">
                                Service Fee: {{googlePayFundRequest.FeeAmount | toCurrency}}
                            </label>
                            <label class="listtextbold" >
                                Total: {{TotalAmount | toCurrency}}
                            </label>
                         </div>
                         <!-- <smallbutton  @click="submitFunds()" toplabel="Confirm" :disabled="disableSubmit"/> -->

                         <div v-if="googlePayProperties!=null">
                            <google-pay-button
                            environment="TEST"
                            button-type="plain"
                            button-color="black"
                            v-bind:paymentRequest.prop=googlePayProperties
                            v-on:loadpaymentdata="onLoadPaymentData"
                            v-on:error="onError"
                            
                            ></google-pay-button>
                         </div>
                         


                        <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Close"/>
                        <div>
                            <label class="responsemessage">{{responseMessage}}</label>
                        </div>
                    </form>
                </div>
                
            
            
        </template>
      </actionmodal>

      
    </div>
</template>

<script>
import datamethods from '../../datamethods.js'
import {mapFields} from 'vuex-map-fields'
import format from '../../format.js'
import smallbutton from '../controls/button.vue'
import linkbutton from '../controls/linkbutton.vue'
import actionmodal from './actionmodal.vue'
import formentry from '../controls/entry.vue'
import confirm from './confirm.vue'
import googlepay from '../services/googlepay.js'
export default {
    name:'addfunds_google',
    components:{
        smallbutton,
        actionmodal,
        formentry,
        linkbutton,
        confirm
    },
    props:{
        account:{
            type:Object,
            required:true
        }
        
    },
    mixins:[datamethods,format,googlepay],
    data(){
        return{
            trueParam:true,
            responseMessage:'',
            pleaseWait:false,

           
            showConfirm:false,
            disableSubmit:false
        }
    },
    computed:{
        TotalAmount(){
            return this.googlePayFundRequest.FeeAmount + this.googlePayFundRequest.TaxAmount + this.googlePayFundRequest.Amount
        },
        ...mapFields([
            'disableAddFunds',
            'currentWallet',
            'googlePayProperties',
            'googlePayFundRequest'

        ]),
        titleText(){
            
            return "Add Funds Google"
            
        },
        getConfirmText(){
            return "You are about to " + this.titleText + " using the wallet of " + this.currentWallet.Name + ". Do you want to continue?"
        },
        disableStartAddFunds(){
            if(this.disableAddFunds){return true}
            if(this.currentWallet.walletTokenList.length==0){return true}
            return false
        },
        LimitToDue(){
            if(window.LIMIT_PAY_TO_DUE==undefined){
                return true
            }else{
                return window.LIMIT_PAY_TO_DUE
            }
        },
        
    },
    methods:{
        beforeAPI(){
            this.pleaseWait=true
            this.responseMessage=''
        },
        
        startAddFunds(){
            this.googlePayProperties=null
            this.responseMessage=''
            this.googlePayFundRequest.ID=this.account.ID
            this.googlePayFundRequest.Name=this.account.Name

            this.googlePayFundRequest.TokenID=0
            this.googlePayFundRequest.Amount=''
            this.googlePayFundRequest.FeeAmount=0
            this.googlePayFundRequest.TaxAmount=0
            


            this.showConfirm=false
            this.disableSubmit=false

            

            this.$refs.mymodal.openModal()
            
        },

    async calcFees(){
        if(this.$refs.addfundsform.checkValidity()){
            //validate amt
            if(this.LimitToDue){
                if(Number(this.googlePayFundRequest.Amount)> Number(this.account.amountDue)){
                    console.log('toomuch')
                    this.responseMessage="Please enter an amount less than or equal to the amount due."
                    return
                }
            }


            this.beforeAPI();
            let req = {
                initialAccountFundList:[this.googlePayFundRequest]
            }
            var response = await this.callAPI(req,'getfee')
            
            
            if(response.Successful){
                this.showConfirm=true
                this.googlePayFundRequest=response.initialAccountFundList[0]

                //set info in store so googlepay can get to it
                this.getGoogleProperties()
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
        }
    },
    async GetTax(){
 
        //create req
        let req = {
            Product:{
                id:-1,
                price:this.googlePayFundRequest.Amount
            }
            
        }
        //call
        this.$store.dispatch('beforeAPI');
        var response = await this.callAPI(req,'gettax')
        //handle response
        if(response.Successful){
            var taxamount = response.responseDouble
            console.log(taxamount)
            //add the tax to the record  
            this.googlePayFundRequest.TaxAmount=taxamount
            
        
            this.calcFees();//now we can add the fees!
        }else{
            this.message = response.Message
        }
        this.pleaseWait=false;
        },
    async getGoogleProperties(){
 
        //create req
       let req = {
            initialAccountFundList:[this.googlePayFundRequest],
            isInstallment:true,
            installmentNumber:1,
            installmentCount:3
        }
        //call
        this.$store.dispatch('beforeAPI');
        var response = await this.callAPI(req,'googlepayproperties')
        //handle response
        if(response.Successful){
           
            this.googlePayProperties = response.googlePayProperties
           // console.log('dynamic:', JSON.stringify(this.googlePayProperties));
           // console.log('hardcoded:', JSON.stringify(this.googlePayExample));
        }else{
            this.message = response.Message
        }
        this.pleaseWait=false;
        },
    async submitFunds(){
      //set the recurring flag
      

      console.log("submit funds")
      this.disableSubmit=true;
      this.beforeAPI();
      let req = {
            initialAccountFundList:[this.googlePayFundRequest],
            isInstallment:true,
            installmentNumber:1,
            installmentCount:3
        }
      var response = await this.callAPI(req,'paymenttoaccount_rawach')

      if(response.Successful){
       
        this.$emit('refresh')
        this.responseMessage="Submit Funds Successful"
        this.$refs.mymodal.closeModal()
      }else{
        this.responseMessage = response.Message
        this.disableSubmit=false;
      }
      this.pleaseWait=false;
      
    },
    cancelConfirm(){
      this.showConfirm=false

    },
    clearFundRequest(){
      this.googlePayFundRequest={
        ID:0,
        Name:'',
        TokenID:0,
        Amount:'',
        FeeAmount:0
      }
    },
    
       
        
    }
}
</script>

<style>

</style>





























